import * as React from 'react';
import * as FormulaStore from '@/redux/pages/formula';
import * as ConfirmStore from '@/redux/ui/confirm';
import store from '@/redux/index';
import { PickerBox } from '@/pages/components/picker';
import { connect } from 'react-redux';
import { parse } from 'query-string'; 

const Toast = require('react-toast-mobile');

interface IProps {
    component: any[];
    component2: string[];
    model: string[];
    quality: string[];
    history: any;
    location: any;
}

class FormulaComponent extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
        let index = parse(this.props.location.search).index || 0;
        index = Number(index);
        if (!this.props.component[index]) { 
            index = 0;
        }
        this.state = {
            index,
            componentList: [
                {
                    name: '组分A',
                    value: '1',
                }, {
                    name: '组分B',
                    value: '2',
                }, {
                    name: '组分C',
                    value: '3',
                }
            ], // 组分内容
            modelComponentName: this.props.component[index].name, // 组分
            modelComponentValue: this.props.component[index].value, // 成分
            modelComponent2: this.props.component2[index], // 成分
            modelModel: this.props.model[index], // 型号
            modelFraction: this.props.quality[index], // 质量
        };
    }

    public componentDidMount() { 

    }

    public render() {
        const state = this.state;
        return (
            <section className="expert-edit">
                <div className="expert-edittop">
                    <div className="expert-edititem" onClick={() => this.selectComponent()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            组分
                        </div>
                        <div className="expert-editgroup">
                            <p className={state.modelComponentName ? 'active' : ''}>{state.modelComponentName || '请选择'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            成分
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请输入" value={state.modelComponent2}
                                onChange={() => this.inputChange('modelComponent2')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            型号
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请输入" value={state.modelModel}
                                onChange={() => this.inputChange('modelModel')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            质量分数%
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请输入" value={state.modelFraction}
                                onChange={() => this.inputChange('modelFraction')} />
                        </div>
                    </div>
                </div>
                <div className="expert-editbottom">
                    <button className="btn-submit" onClick={() => this.submitAction()}>确定</button>
                    {
                        this.props.component.length > 1 ? <button className="btn-delete-a" onClick={() => this.deleteAction()}>删除</button> : null
                    }
                </div>
            </section>
        )
    }
    /**
     * 处理输入框文本变化
     * @param modelName {string} 模块名称
     */
    private inputChange(modelName: string) {
        this.setState({
            [modelName]: (event as any).target.value
        });
    }

    // 选择成分
    private selectComponent() { 
        (PickerBox as any).open({
            data: [{
                displayValue(item: any) {
                    return item.name;
                },
                list: this.state.componentList,
            }],
            // 成功回调
            onConfrim: (data: any) => {
                this.setState({
                    modelComponentName: data.name,
                    modelComponentValue: data.value
                });
            }
        });
    }

    // 提交
    private submitAction() { 
        if (this.state.modelComponent1 === '') { 
            return Toast.T.notify('请填写组分');
        }
        if (this.state.modelComponent2 === '') {
            return Toast.T.notify('请填写成分');
        } else if (this.state.modelComponent2.length > 100) { 
            return Toast.T.notify('成分内容最多不能超过100个字');
        }
        if (this.state.modelModel === '') {
            return Toast.T.notify('请填写型号');
        }
        if (this.state.modelFraction === '') {
            return Toast.T.notify('请填写质量');
        } else if (this.state.modelFraction.length > 10) { 
            return Toast.T.notify('质量分数最多不能超过10个字');
        } else if (/^[\u2E80-\u9FFFA-Za-z]+$/img.test(this.state.modelFraction)) { 
            return Toast.T.notify('质量分数仅支持数字和符号');
        }
        const [tempComponent, tempComponent2, tempModel, tempQuality] =
            [this.props.component, this.props.component2, this.props.model, this.props.quality];
        tempComponent[this.state.index] = {
            name: this.state.modelComponentName,
            value: this.state.modelComponentValue
        }
        tempComponent2[this.state.index] = this.state.modelComponent2;
        tempModel[this.state.index] = this.state.modelModel;
        tempQuality[this.state.index] = this.state.modelFraction;
        store.dispatch({
            type: FormulaStore.types.CONCAT,
            concatData: {
                component: tempComponent,
                component2: tempComponent2,
                model: tempModel,
                quality: tempQuality
            }
        });
        this.props.history.goBack();
    }

    // 删除
    private deleteAction() { 
        store.dispatch({
            type: ConfirmStore.types.CONFIRM_SHOW,
            data: {
                text: '是否确认删除?',
                onConfirm: () => { 
                    const [tempComponent, tempComponent2, tempModel, tempQuality] =
                        [this.props.component, this.props.component2, this.props.model, this.props.quality];
                    tempComponent.splice(this.state.index, 1);
                    tempComponent2.splice(this.state.index, 1);
                    tempModel.splice(this.state.index, 1);
                    tempQuality.splice(this.state.index, 1);
                    setTimeout(() => {
                        store.dispatch({
                            type: FormulaStore.types.CONCAT,
                            concatData: {
                                component: tempComponent,
                                component2: tempComponent2,
                                model: tempModel,
                                quality: tempQuality
                            }
                        });
                        this.props.history.goBack();
                     });
                }
            }
        });
        
    }
}

const mapStateToProps = (state: any): FormulaStore.IFormulaStoreState => { 
    return {
        ...state.formulaReducers
    }
}

export default connect(mapStateToProps)(FormulaComponent);